/**
 * ChristmasTreeIcons.jsx
 * Created by Destin Frasier on 08/19/19.
 */

import ChristmasTreeIconSingleton from './christmasTreeIconSingleton';
import BaseIcon from '../BaseIcon';


class ChristmasTreeIcon extends BaseIcon {
    constructor(props) {
        super(props);

        this.iconSingleton = ChristmasTreeIconSingleton;
    }
}

export class IconDiameter extends ChristmasTreeIcon {}
IconDiameter.defaultProps = {
    iconName: 'rec-icon-christmas-tree-diameter',
    iconClass: 'rec-icon-christmas-tree-diameter',
    alt: 'Christmas Tree Stump Diameter'
};

export class IconHeight extends ChristmasTreeIcon {}
IconHeight.defaultProps = {
    iconName: 'rec-icon-christmas-tree-height',
    iconClass: 'rec-icon-christmas-tree-height',
    alt: 'Christmas Tree Stump Height'
};

export class IconNoCut extends ChristmasTreeIcon {}
IconNoCut.defaultProps = {
    iconName: 'rec-icon-christmas-tree-cut',
    iconClass: 'rec-icon-christmas-tree-cut',
    alt: 'No Cutting Off the Top Of Trees'
};
